import type { HelpFile } from '../../types/help'
import { BeneficiaryMultiSelectTestIds } from '../../../testids/BeneficiaryMultiSelectTestIds'

export const beneficiaryMultiSelectHelp: HelpFile = {
  docPage: '/docs/governance/access-requests',
  texts: {
    [BeneficiaryMultiSelectTestIds.beneficiaryChips]:
      'Ausgewählte Begünstigte — Klick auf das X entfernt einen Chip, Rücktaste im Suchfeld entfernt den letzten Chip.',
  },
}
